import React, { FC, useEffect } from "react"
import Button from "@components/Button"
import { Container, Subtitle } from "@components/styles"
import Card from "@components/LatestNews/Card"
import { AccessibleIcon } from "@radix-ui/react-accessible-icon"
import { scrollTo } from "@utils/scrollTo"
import type { LatestNewsProps } from "./types"
import {
    CardsWrapper,
    Category,
    CategoriesWrapper,
    LatestNewsWrapper,
    Title,
    TitleWrapper,
    PaginationWrapper,
    PaginationItem
} from "./styles"

const LatestNews: FC<LatestNewsProps> = ({
    subtitle,
    title,
    items,
    categories,
    nextPage,
    prevPage
}) => {
    useEffect(() => {
        if (window.location.hash === "#keep-position") {
            scrollTo("content-hero")
        }
    }, [])

    return <LatestNewsWrapper>
        <Container>
            <Subtitle>{subtitle}</Subtitle>
            <TitleWrapper>
                <Title>{title}</Title>
                <Button
                    color="grey"
                    link="/nieuws"
                >
                    Bekijk al het nieuws
                </Button>
            </TitleWrapper>
            {categories && <CategoriesWrapper>
                {categories?.map((category) => (
                    <Category
                        key={category.slug}
                        to={`/nieuws/${category.slug}#keep-position`}
                        active={category.active}
                    >
                        {category.title}
                    </Category>
                ))}
            </CategoriesWrapper>}
            {items && <CardsWrapper>
                {items.map((item) => (
                    <Card key={item.slug} {...item} />
                ))}
            </CardsWrapper>}
            {(nextPage || prevPage) && <PaginationWrapper>
                <PaginationItem as={!prevPage ? "span" : undefined} to={`${prevPage ? `${prevPage}#keep-position` : ""}`} disabled={!prevPage}>
                    <AccessibleIcon label="previous news items">
                        <img
                            src="/icons/chevron-left.svg"
                            alt="chevron left"
                            width={24}
                            height={24}
                        />
                    </AccessibleIcon>
                </PaginationItem>
                <PaginationItem as={!nextPage ? "span" : undefined} to={`${nextPage ? `${nextPage}#keep-position` : ""}`} disabled={!nextPage}>
                    <AccessibleIcon label="next news items">
                        <img
                            src="/icons/chevron-right.svg"
                            alt="chevron right"
                            width={24}
                            height={24}
                        />
                    </AccessibleIcon>
                </PaginationItem>
            </PaginationWrapper>}
        </Container>
    </LatestNewsWrapper>
}

export default LatestNews
